import styled from '@emotion/styled';

export const MainBlock = styled.div`
  padding: 24px 24px 0 24px;

  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SectionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;

  overflow-x: auto;
`;
